// Validation regex patterns
export const ValidationPatterns = {
  // Email validation
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,

  // Password: En az 8 karakter, en az bir büyük harf, en az bir küçük harf, en az bir rakam, en az bir özel karakter içermeli
  // Özel karakterler: Harf ve rakam olmayan tüm karakterler (boşluk hariç)
  PASSWORD_STRONG: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z\d\s])[^\s]{8,}$/,

  // Password: En az 6 karakter
  PASSWORD_MIN: /^.{6,}$/,

  // Türk telefon numarası: +90 ile başlayan veya 0 ile başlayan
  PHONE_TR: null, // /^(\+90|0)?[5][0-9]{9}$/,

  // Genel telefon: + ile başlayan veya rakamlar
  PHONE_GENERAL: null, // /^(\+)?[0-9]{10,15}$/,

  // İsim: Sadece harf, boşluk ve Türkçe karakterler
  NAME: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/,

  // Minimum 2 karakter
  MIN_2_CHARS: /^.{2,}$/,

  // Boş olmamalı
  NOT_EMPTY: /.+/,

  // URL validation (http, https, ftp)
  URL: /^(https?|ftp):\/\/[^\s/$.?#].[^\s]*$/i,

  // Latitude: -90 ile 90 arası (ondalıklı sayılar dahil)
  LATITUDE: /^-?([0-8]?[0-9]|90)(\.\d+)?$/,

  // Longitude: -180 ile 180 arası (ondalıklı sayılar dahil)
  LONGITUDE: /^-?([0-1]?[0-7]?[0-9]|180)(\.\d+)?$/,

  // İngilizce isim: Harf, boşluk, tire ve apostrof
  NAME_EN: /^[a-zA-Z\s'-]+$/,

  // Şehir/İl/İlçe: Harf, boşluk ve Türkçe karakterler
  CITY_PROVINCE: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/,
};

// Validation error messages
export const ValidationMessages = {
  EMAIL: "Geçerli bir e-posta adresi giriniz",
  PASSWORD_STRONG: "Şifre en az 8 karakter olmalı ve büyük harf, küçük harf, rakam ve özel karakter içermelidir",
  PASSWORD_MIN: "Şifre en az 6 karakter olmalıdır",
  PHONE_TR: "Geçerli bir Türk telefon numarası giriniz (örn: +905551234567 veya 05551234567)",
  PHONE_GENERAL: "Geçerli bir telefon numarası giriniz",
  NAME: "Sadece harf karakterleri kullanılabilir",
  MIN_2_CHARS: "En az 2 karakter girmelisiniz",
  REQUIRED: "Bu alan zorunludur",
  URL: "Geçerli bir URL giriniz (örn: https://www.example.com)",
  LATITUDE: "Enlem -90 ile 90 arasında olmalıdır",
  LONGITUDE: "Boylam -180 ile 180 arasında olmalıdır",
  NAME_EN: "Sadece harf karakterleri, boşluk, tire ve apostrof kullanılabilir",
  CITY_PROVINCE: "Sadece harf karakterleri kullanılabilir",
};

